import React from "react"
import logo from "../assets/images/coding.png"
const Banner = () => {
    return (
        <>

            <div class="text-center banner-component" id="home">
                <div class="row">
                    <div class="col-md-8 p-0 banner-col ">
                        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3">
                            <h1 className="banner-subtitle fade-in"> &lt;¡Hello world!&gt;  </h1>
                            <p className="banner-title fade-in" style={{ animationDelay: '0.2s' }}>Me llamo Federico Caballero</p>
                            <p className="banner-text fade-in" style={{ animationDelay: '0.4s' }}>
                                Soy desarrollador Front-End y Mobile con más de 2 años de experiencia profesional. <br />

                                Graduado como Analista Programador Universitario en la UNNE y actualmente cursando el último año de la Licenciatura en Sistemas de Información.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 p-3 banner-img fade-in" style={{ animationDelay: '0.6s' }}>
                        <img src={logo} class="img-fluid" alt="ismg3" />
                    </div>
                </div>
            </div>
        </>
    )

}

export default Banner;
